export default "__VITE_ASSET__CFQ4d6c8__"